<template>
    <section class="py-16">
        <div class="container mx-auto">
            <div class="grid grid-cols-12 gap-6 items-end mb-14">
                <div class="col-span-12">
                    <h2 class="text-5xl leading-tight text-dim_dark mb-8">
                        3D туры дизайнерских <br> проектов
                    </h2>
                    <button class="prevArrow h-10 w-12 bg-dim_gold_2 mr-4">
                        <span class="mdi mdi-arrow-left text-lg"></span>
                    </button>
                    <button class="nextArrow h-10 w-12 bg-dim_gold_2">
                        <span class="mdi mdi-arrow-right text-lg"></span>
                    </button>
                </div>
            </div>

            <div class="">
                <swiper
                    :modules="modules"
                    :slides-per-view="3"
                    :space-between="24"
                    :navigation="{ nextEl: '.nextArrow', prevEl: '.prevArrow'}"
                    class="mySwiper2"
                >
                    <swiper-slide v-for="(item, index) in 6" :key="index">
                        <ThreeDCard />
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </section>
</template>

<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { Navigation } from 'swiper/modules'
import ThreeDCard from '@/components/ui/ThreeDCard.vue'

export default {
    components:{
        ThreeDCard,
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            modules: [Navigation]
        }
    }

}
</script>